import { render, staticRenderFns } from "./AccreditationFiles.vue?vue&type=template&id=7cd6a074&scoped=true"
import script from "./AccreditationFiles.vue?vue&type=script&lang=js"
export * from "./AccreditationFiles.vue?vue&type=script&lang=js"
import style0 from "./AccreditationFiles.vue?vue&type=style&index=0&id=7cd6a074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6a074",
  null
  
)

export default component.exports